import { useState, useEffect, useRef } from "react";
import api from "../services/api";
import { useToast } from "../context/ToastContext";
import { useForm } from "react-hook-form";
import { SCDropdown, SCFieldset, SCButton, SCInputText, SCInputTextarea, SCDialog, SCCheckbox, } from "../components";
import { useAuth } from "../providers/auth";
import AlunoSituacaoForm from "./AlunoSituacaoForm";
import util from '../utilities/util';
import ConfiguracaoFormulasForm from "./ConfiguracaoFormulasForm";
import Loading from "../components/Loading";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { CheckboxChangeParams } from "primereact/checkbox";
import { format } from "date-fns";

const BoletimProcessamento = () => {
    const toast = useToast();
    const tarefa = "BoletimProcessamento";
    const { periodoSelecionado } = useAuth();

    const [avaliacoes, setAvaliacoes] = useState<any>([]);
    const [cursos, setCursos] = useState<any>([]);
    const [turmas, setTurmas] = useState<any>([]);
    const [todosSelecionados, setTodosSelecionados] = useState(false);
    const [loading, setLoading] = useState<any>(false);

    const methods = useForm({});
    const { handleSubmit, control, formState: { errors }, watch, setValue, getValues, } = methods;

    const watchAvaliacoes = watch('AvaliacoesId');
    const watchCursos = watch('CursoId');

    const load = async () => {
        setLoading(true)

        const avaliacoes = await api.get('/boletimAvaliacoes', {
            params: {
                EmpresaId: periodoSelecionado?.EmpresaId,
                Ano: periodoSelecionado?.Ano,
                Sequencial: periodoSelecionado?.Sequencial,
            }
        });
        setAvaliacoes(avaliacoes.data)

        const curso = await api.get('/curso', {
            params: {
                EmpresaId: periodoSelecionado?.EmpresaId
            }
        });
        setCursos(curso.data)

        setLoading(false)
    };

    useEffect(() => {
        load();
    }, []);

    const handleCheckboxChange = (rowData: any, checked: boolean) => {
        const updatedAlunos = turmas.map((item: any) => {
            if (item.TurmaId === rowData.TurmaId) {
                return { ...item, Selecionado: checked ? 1 : 0 };
            }
            return item;
        });

        setTurmas(updatedAlunos);
    };

    const handleSelectAllChange = (e: any) => {
        const isChecked = e.target.checked;
        setTodosSelecionados(isChecked);

        const updatedTurmas = turmas.map((item: any) => {
            if (item.AlunosPeriodoId === e.AlunosPeriodoId) {
                return { ...item, Selecionado: isChecked ? 1 : 0 };
            }
            return item;
        });

        if (isChecked) {
            updatedTurmas.forEach((item: any) => {
                item.Selecionado = 1
            })
            setTurmas(updatedTurmas)
        } else {
            updatedTurmas.forEach((item: any) => {
                item.Selecionado = 0
            })
            setTurmas(updatedTurmas)
        }
    };

    const pesquisar = async () => {
        setLoading(true)

        const turma = await api.get('/turma/list', {
            params: {
                EmpresaId: periodoSelecionado?.EmpresaId,
                Ano: periodoSelecionado?.Ano,
                Sequencial: periodoSelecionado?.Sequencial,
                CursoId: watchCursos,
            }
        });
        const processarSelecionado = turma.data.map((item: any) => {
            if (item.FaltaProcessar === true) {
                return { ...item, Selecionado: 1 };
            }
            return { ...item, Selecionado: 0 };
        });
        setTurmas(processarSelecionado)

        setLoading(false)
    };

    const formatDate = (value: any) => {
        if (!value) return '';
        const date = new Date(value);
        if (isNaN(date.getTime())) return '';
        return format(date, 'dd/MM/yyyy');
    };

    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <div className="flex justify-content-center align-items-center p-2 border-round-top-md text-white" style={{ backgroundColor: "#0772B3" }}>
                        <h5 className="m-0 flex flex-1 align-items-center justify-content-center">
                            Processamento Boletim
                        </h5>
                    </div>

                    <SCFieldset legend="Filtros" className="mt-2" >
                        <div className="grid">
                            <div className="col-5">
                                <SCDropdown
                                    control={control}
                                    name="AvaliacoesId"
                                    options={avaliacoes}
                                    optionValue="AvaliacoesId"
                                    optionLabel="Descricao"
                                    // onChange={(e) => handleAvaliacoes(e.target.value)}
                                    value={watchAvaliacoes}
                                    label="Avaliação"
                                />
                            </div>
                            <div className="col-5">
                                <SCDropdown
                                    control={control}
                                    name="CursoId"
                                    options={cursos}
                                    optionValue="CursoId"
                                    optionLabel="Descricao"
                                    // onChange={(e) => handleAvaliacoes(e.target.value)}
                                    value={watchCursos}
                                    label="Curso"
                                />
                            </div>
                            <div className="col-2 pt-4">
                                <SCButton
                                    icon="pi pi-search"
                                    className="p-button-success"
                                    onClick={() => pesquisar()}
                                    style={{ width: '100%' }}
                                    label="Pesquisar"
                                />
                            </div>
                        </div>
                    </SCFieldset>

                    {loading ? <Loading /> : (<>
                        <DataTable
                            size='small'
                            stripedRows
                            dataKey="id"
                            value={turmas}
                            currentPageReportTemplate="{first} a {last} de {totalRecords}"
                            emptyMessage="Nenhum registro encontrado."
                            editMode='cell'
                            responsiveLayout="scroll"
                        >

                            <Column field="Codigo" header="Turma" sortable headerStyle={{ width: '10%' }} />
                            <Column field="Descricao" header="Descrição" sortable headerStyle={{ width: '50%' }} />
                            <Column field="ProcessamentoBoletimData" header="Data" sortable headerStyle={{ width: '10%' }}
                                body={(rowData) => formatDate(rowData.ProcessamentoBoletimData)} />
                            <Column field="ProcessamentoBoletimHora" header="Hora" sortable headerStyle={{ width: '10%' }} />
                            <Column field="ProcessamentoBoletimUsuarioId" header="Usuário" sortable headerStyle={{ width: '10%' }} />
                            <Column field="ProcessamentoBoletimAvaliacaoId" header="Avaliação" sortable headerStyle={{ width: '10%' }} />
                            <Column
                                header={
                                    <div>
                                        <SCCheckbox
                                            label='Selecionar Todos'
                                            name='selecionarTodos'
                                            checked={todosSelecionados}
                                            onChange={handleSelectAllChange}
                                        />
                                    </div>
                                }
                                body={(rowData: any) => (
                                    <div className="col-12 flex justify-content-center">
                                        <SCCheckbox
                                            key={rowData.TurmaId}
                                            checked={rowData.Selecionado === 1}
                                            onChange={(e: CheckboxChangeParams) => handleCheckboxChange(rowData, e.checked)}
                                            id={rowData.AlunosPeriodoId}
                                            name="Selecionado"
                                            value={rowData.Selecionado === 1}
                                        />
                                    </div>
                                )}
                                alignHeader='center'
                                align='center'
                            />
                        </DataTable>
                    </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BoletimProcessamento;
